import React, { useState, useEffect} from 'react';
 
import { useNavigate } from "react-router-dom"
import AxiosFetchData from "../pages/AxiosFetchData"
import { CatchWrapperAsync } from "../utils/catchwrapper"
import Bindcomponent from '../utils/bindcomponent';
import Helper from '../pages/Helper';
import { useId } from "react"
export const useRequestMaterial = () => {
    const [message,setmessage] = useState('')
    const [tipe,settipe] = useState('')
    const [rows,setRows] = useState([])
    const [roleAccess, setRoleAccess] = useState([]);
    const [userName, setUserName] = useState('')
    const [userId, setUserId] = useState('')
    const [approvalopen , setapprovalopen] = useState(false)
    const [projectId , setProjectId] = useState('000000')
    const [materialId , setMaterialId] = useState('')
    const [rowsDetail, setRowsDetail] = useState({})
    const [openRetention, setOpenRetention] = React.useState(false);
    const [notes, setNotes] = useState('')
    const [status, setStatus] = useState(1)
    const navigate = useNavigate();
    const [selectedOptionProject,setSelectedOptionProject] = useState('');
    const [openMaterialDetail,setOpenMaterialDetail] = useState(false)
     
    
    useEffect(()=>{
        fetch("00000000000000")
        setSelectedOptionProject({label :'ALL PROJECT', value :"00000000000000"})
    },[])

    const fetch = async (id) => {
        CatchWrapperAsync(async ()=>{
            const response = await AxiosFetchData.get(`GetMaterialRequest/${id}`).refreshToken(navigate,"requestmaterialapproval")
            setRows(response.data.data.map(mapping));
            setRoleAccess(response.roleaccess)
            setUserName(response.decode.name)
            setUserId(response.decode.userID)
        },setmessage,settipe)
        
    }

    function mapping(item){
        item.status_name =  statusMaterial[item.status]
        return item
    }

    const statusMaterial ={
        "0" : "Pending",
        "2" : "Approved",
        "3" : "Declined"
    }

    const handleApproved = async (id) =>{
      //  setMaterialId((prev) => prev = id)
      //  setStatus((prev) => prev = 2)
      //  setNotes('')
        await handleSave(id,2)
       // setOpenRetention(true)
    }

    const handleDeclined = async (id) =>{
       //  setMaterialId((prev) => prev = id)
       //  setStatus((prev) => prev = 3)
       //  setNotes('')
         await handleSave(id, 3)
       //  setOpenRetention(true)
    }

    const handleSave = async (materialId, status) => {
       // e.preventDefault()
        CatchWrapperAsync(async()=>{
            var data = {
                status : status,
                approval_by : userId,
                approval_at : Date.now(),
                //ket : notes,
                updated_by : userId,
                updated_at : Date.now()
            }
            await AxiosFetchData.post(`UpdateMaterialStatus/${materialId}`,data).refreshToken(navigate,"requestmaterialapproval")
            await fetch(selectedOptionProject.value)
            setOpenRetention(false)
           
        },setmessage,settipe)
    }

    const handleRetentionClose = () => {
        setOpenRetention(false);
    }
 const columnsDetail = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        { field: 'product_name', headerName: 'Product Name', width: 350 },
        { field: 'unit_id', headerName: 'Unit ID', width: 100 },
        { field: 'unit_name', headerName: 'Unit Name', width: 100 },
        { field: 'qty', headerName: 'Qty', width: 100 },
        { field: 'hpp', headerName: 'HPP', width: 150 },
        { field: 'cost', headerName: 'Total', width: 150 },
 ]    

    const columns = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        { field: 'request_date', headerName: 'Request Date', width: 150 },
        { field: 'project_id', headerName: 'Project ID', width: 150 },
        { field: 'project_name', headerName: 'Project Name', width: 250 },
        { field: 'descriptions', headerName: 'Descriptions', width: 350 },
        // { field: 'status', headerName: 'Status', width: 150 },
        { field: 'status_name', headerName: 'Status', width: 150 },
        {
          field: 'actions',
          headerName: 'Actions',
          width: 300,
          renderCell: (params) => (
            <>
            <Bindcomponent component='ConfirmationButton' classname='btn btn-primary mr-2' text="Do you want approved this data?" type="button"  disabled={!roleAccess.UPDATE} onClick={async () => await handleApproved(params.row.id)}>Approved</Bindcomponent>
            <Bindcomponent component='ConfirmationButton' classname='btn btn-danger mr-2' text="Do you want declined this data?" type="button" disabled={!roleAccess.UPDATE}  onClick={async () => await handleDeclined(params.row.id)}>Declined</Bindcomponent>
          
            <button onClick={() =>
                            {
                                
                                setRowsDetail(params.row.detail.map((item)=>({
                                    ...item,
                                    cost :  Helper.formatAsCurrency(item.cost),
                                    hpp : Helper.formatAsCurrency(item.cost / item.qty)
                                })))
                                setOpenMaterialDetail(true)
                            }}  
                            className="btn btn-info"
            >
                Detail
            </button>
            </>
          ),
      },
    ];

    const handleSelectedProject = (option) =>{
        setSelectedOptionProject(option)
        fetch(option.value)
    }

    return {message,setmessage,tipe,settipe,rows,columns,approvalopen,setapprovalopen,rowsDetail,projectId,
             openRetention,handleRetentionClose,notes,setNotes,handleSave,selectedOptionProject,
             handleSelectedProject,materialId,openMaterialDetail,setOpenMaterialDetail,columnsDetail
    }
}